import Icon from '@ant-design/icons';

const Text = (props: any) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.3844 2.43335H3.62876C3.55794 2.43335 3.5 2.4913 3.5 2.56214V4.62274C3.5 4.69358 3.55794 4.75153 3.62876 4.75153H4.53007C4.60089 4.75153 4.65883 4.69358 4.65883 4.62274V3.59244H7.36277V12.6076H5.88204C5.81122 12.6076 5.75328 12.6655 5.75328 12.7364V13.6379C5.75328 13.7087 5.81122 13.7667 5.88204 13.7667H10.1311C10.2019 13.7667 10.2598 13.7087 10.2598 13.6379V12.7364C10.2598 12.6655 10.2019 12.6076 10.1311 12.6076H8.65036V3.59244H11.3543V4.62274C11.3543 4.69358 11.4122 4.75153 11.4831 4.75153H12.3844C12.4552 4.75153 12.5131 4.69358 12.5131 4.62274V2.56214C12.5131 2.4913 12.4552 2.43335 12.3844 2.43335Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const TextIcon = (props: any) => <Icon component={Text} {...props} />;
